import { gql } from '@apollo/client';

export const LIST_ASSETS_QUERY = gql`
  query ListAssets($isActive: Boolean) {
    listAssets(input: { isActive: $isActive }) {
      statusCode
      message
      assets {
        id
        assetId
        name
        type
        gold_weight
        copper_weight
        copper_price
        certificateUrl
        imageUrl
        nftTokenId
        pricePerToken
        nav
        navLastUpdated
        stageMultiplier
        tokenizedPercentage
        totalTokens
        totalMintedTokens
        minimumInvestmentAmount
        isActive
        chain
        tokenStandard
        requireAccreditedInvestor
        tokenRef
        explorerUrl
        erc3643 {
          tokenAddress
          identityRegistry
          symbol
          decimals
          # ACE enforcement state. A token whose PolicyEngine never attached reverts on
          # every transfer and mint, and looks completely normal without this.
          compliance {
            engine
            requestedEngine
            inSync
            aceTargetId
            aceTargetStatus
            policyEngineAddress
            protectedMethods
          }
        }
      }
    }
  }
`;
